<div class="modal-header">
  <h4 class="modal-title">{{'newConnectionPopup.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner pt-2">
    <form novalidate [formGroup]="form">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'newConnectionPopup.name.label' | translate}}</label>
        <div class="col-md-2">
          <input type="text" class="form-control border" name="connectionNamePrefix" readonly value="{{connectionNamePrefix}}">
        </div>
        <div class="col-md-6">
          <input type="text" class="form-control border" name="connectionName" formControlName="connectionName"
            inputRestricter="^[0-9_]*$" [class.is-invalid]="getInputError(form.get('connectionName'))">
          <div class="invalid-feedback">{{getInputError(form.get('connectionName'))}}</div>
        </div>
      </div>
      <div class="mb-3 row">
        <div class="col-md-8 offset-md-4">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="autoGenerateConnectionName" formControlName="autoGenerateConnectionName"
              (change)="autoGenerateConnectionNameHandler()">
            <label class="form-check-label" for="autoGenerateConnectionName">{{'newConnectionPopup.autoName' | translate}}</label>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label">{{'newConnectionPopup.type' | translate}}</label>
        <div class="col-md-8">
          <select class="form-control border" id="connectionType" name="connectionType" formControlName="connectionType">
            @for (connectionType of connectionTypes; track $index) {
              <option [ngValue]="connectionType">
                {{'newConnectionPopup.' + connectionType | translate}}
              </option>
            }
          </select>
        </div>
      </div>
      @if (form.get('connectionType').value === connectionTypes[0]) {
        <div class="mb-3 row">
          <div class="col-md-8 offset-md-4">
            <select class="form-control border" id="connectionSide" name="connectionSide" formControlName="connectionSide">
              <option value="ACCEPTING">{{'property.type.accepting' | translate}}</option>
              <option value="GIVING">{{'property.type.giving' | translate}}</option>
            </select>
          </div>
        </div>
      }
      @if (form.get('connectionType').value === connectionTypes[1]) {
        <div class="mb-3 row">
          <div class="col-md-8 offset-md-4">
            <select class="form-control border" id="textureType" name="textureType" formControlName="textureType">
              @for (textureType of textureTypes; track $index) {
                <option [ngValue]="textureType">
                  {{'newConnectionPopup.textureAreaType.' + textureType | translate}}
                </option>
              }
            </select>
          </div>
        </div>
      }
      <div class="mb-3 row">
        <div class="col-md-8 offset-md-4">
          <div class="form-check">
            <input type="radio" class="form-check-input" id="newRectangleShapeType" name="connectionShapeType" [value]="ShapeType.RECTANGLE" formControlName="connectionShapeType">
            <label class="form-check-label" for="newRectangleShapeType">{{'newConnectionPopup.shapeType.rectangle' | translate}}</label>
          </div>
          <div class="form-check mt-3">
            <input type="radio" class="form-check-input" id="newCircleShapeType" name="connectionShapeType" [value]="ShapeType.CIRCLE" formControlName="connectionShapeType">
            <label class="form-check-label" for="newCircleShapeType">{{'newConnectionPopup.shapeType.circle' | translate}}</label>
          </div>
        </div>
      </div>
      @if (form.get('connectionShapeType').value === ShapeType.RECTANGLE) {
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label">{{'newConnectionPopup.length' | translate}}</label>
          <div class="col-md-8">
            <input type="text" class="form-control border" name="connectionLength" inputRestricter="^[0-9\.,]*$"
              [class.is-invalid]="getInputError(form.get('connectionLength'))" formControlName="connectionLength">
            <div class="invalid-feedback">{{getInputError(form.get('connectionLength'))}}</div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label">{{'newConnectionPopup.width' | translate}}</label>
          <div class="col-md-8">
            <input type="text" class="form-control border" name="connectionWidth" inputRestricter="^[0-9\.,]*$"
              [class.is-invalid]="getInputError(form.get('connectionWidth'))" formControlName="connectionWidth">
            <div class="invalid-feedback">{{getInputError(form.get('connectionWidth'))}}</div>
          </div>
        </div>
      } @else {
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label">{{'newConnectionPopup.radius' | translate}}</label>
          <div class="col-md-8">
            <input type="text" class="form-control border" name="connectionRadius" inputRestricter="^[0-9\.,]*$"
              [class.is-invalid]="getInputError(form.get('connectionRadius'))" formControlName="connectionRadius">
            <div class="invalid-feedback">{{getInputError(form.get('connectionRadius'))}}</div>
          </div>
        </div>
      }
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label py-2">{{'connection.position.label' | translate}}</label>
        <div class="col-md-8 py-2">
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="determinePosition" formControlName="determinePosition">
              <label class="form-check-label" for="determinePosition">{{'newConnectionPopup.determinePosition' | translate}}</label>
            </div>
          </div>
          <div class="d-flex mt-3">
            <div class="d-inline-flex me-2">
              <label class="col-form-label me-1">{{'connection.position.x' | translate}}</label>
              <div>
                <input type="text" class="form-control border" name="positionX" inputRestricter="^-?[0-9\.,]*$" formControlName="positionX"
                  [class.is-invalid]="getInputError(form.get('positionX'))" [readonly]="!form.get('determinePosition').value">
                <div class="invalid-feedback">{{getInputError(form.get('positionX'))}}</div>
              </div>
            </div>
            <div class="d-inline-flex me-2">
              <label class="col-form-label me-1">{{'connection.position.y' | translate}}</label>
              <div>
                <input type="text" class="form-control border" name="positionY" inputRestricter="^-?[0-9\.,]*$" formControlName="positionY"
                  [class.is-invalid]="getInputError(form.get('positionY'))" [readonly]="!form.get('determinePosition').value">
                <div class="invalid-feedback">{{getInputError(form.get('positionY'))}}</div>
              </div>
            </div>
            <div class="d-inline-flex">
              <label class="col-form-label me-1">{{'connection.position.z' | translate}}</label>
              <div>
                <input type="text" class="form-control border" name="positionZ" inputRestricter="^-?[0-9\.,]*$" formControlName="positionZ"
                  [class.is-invalid]="getInputError(form.get('positionZ'))" [readonly]="!form.get('determinePosition').value">
                <div class="invalid-feedback">{{getInputError(form.get('positionZ'))}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label py-2">{{'connection.rotation.label' | translate}}</label>
        <div class="col-md-8 py-2">
          <div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="determineRotation" formControlName="determineRotation">
              <label class="form-check-label" for="determineRotation">{{'newConnectionPopup.determineRotation' | translate}}</label>
            </div>
          </div>
          <div class="d-flex mt-3">
            <div class="d-inline-flex me-2">
              <label class="col-form-label me-1">{{'connection.rotation.x' | translate}}</label>
              <div>
                <input type="text" class="form-control border" name="rotationX" inputRestricter="^-?[0-9\.,]*$" formControlName="rotationX"
                  [class.is-invalid]="getInputError(form.get('rotationX'))" [readonly]="!form.get('determineRotation').value">
                <div class="invalid-feedback">{{getInputError(form.get('rotationX'))}}</div>
              </div>
            </div>
            <div class="d-inline-flex me-2">
              <label class="col-form-label me-1">{{'connection.rotation.y' | translate}}</label>
              <div>
                <input type="text" class="form-control border" name="rotationY" inputRestricter="^-?[0-9\.,]*$" formControlName="rotationY"
                  [class.is-invalid]="getInputError(form.get('rotationY'))" [readonly]="!form.get('determineRotation').value">
                <div class="invalid-feedback">{{getInputError(form.get('rotationY'))}}</div>
              </div>
            </div>
            <div class="d-inline-flex">
              <label class="col-form-label me-1">{{'connection.rotation.z' | translate}}</label>
              <div>
                <input type="text" class="form-control border" name="rotationZ" inputRestricter="^-?[0-9\.,]*$" formControlName="rotationZ"
                  [class.is-invalid]="getInputError(form.get('rotationZ'))" [readonly]="!form.get('determineRotation').value">
                <div class="invalid-feedback">{{getInputError(form.get('rotationZ'))}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (form.get('connectionType').value !== connectionTypes[1]) {
        <div class="mb-3 row">
          <label class="col-md-4 col-form-label">{{'newConnectionPopup.multiplicity' | translate}}</label>
          <div class="col-md-8">
            <input type="text" class="form-control border" name="connectionMultiplicity" inputRestricter="^[0-9]*$"
              [class.is-invalid]="getInputError(form.get('connectionMultiplicity'))" formControlName="connectionMultiplicity">
            <div class="invalid-feedback">{{getInputError(form.get('connectionMultiplicity'))}}</div>
          </div>
        </div>
      }
      @if (form.get('copyProperties')) {
        <div class="mb-3 row">
          <div class="col-md-8 col-md-offset-4">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="copyProperties" formControlName="copyProperties">
              <label class="form-check-label" for="copyProperties">{{'newConnectionPopup.copyProperties' | translate}}</label>
            </div>
          </div>
        </div>
      }
      @if (form.get('connectionType').value !== connectionTypes[1]) {
        <div class="mb-3 row">
          <div class="col-md-12">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="connectionDoubleside" formControlName="connectionDoubleside">
              <label class="form-check-label" for="connectionDoubleside">{{'newConnectionPopup.bothsides' | translate}}</label>
            </div>
          </div>
        </div>
      }
    </form>
    @if (
      form.get('connectionType').value !== connectionTypes[1]
      || form.get('connectionType').value === connectionTypes[1]
      && form.get('textureType').value !== textureTypes[2]
      ) {
      <input class="form-control border py-0 px-1" type="color" [(ngModel)]="connectionColor" [ngModelOptions]="{standalone: true}">
    }
    @if (form.get('connectionType').value === connectionTypes[1] && form.get('textureType').value === textureTypes[2]) {
      <div>
        <div class="mb-3 row">
          @if (imageUrl) {
          <label class="col-md-4 col-form-label font-weight-bold">
            {{'newConnectionPopup.label.image' | translate }}:
          </label>
          <img class="ps-3"
              [attr.width.px]="imageContainerWidth"
              [attr.height.px]="imageContainerHeight"
              [src]="imageUrl"
              alt="uploaded image"/>
          } @else {
            <div  class="col-md-4">
              <label class="form-label font-weight-bold">
                {{'newConnectionPopup.label.image' | translate }}:
              </label>
            </div>
            <div class="col-md">
              <input class="form-control is-valid inputfile"
                     id="new-connection-file"
                     name="new-connection-file"
                     type="file"
                     accept="/*.jpeg, /*.jpg, /*.png"
                     (change)="imageUpload($event)">
              <label class="btn btn-primary col-md-12" for="new-connection-file">
                <i class="mdi mdi-upload"></i>
                {{'newConnectionPopup.label.select_image' | translate}}
              </label>
            </div>
          }
        </div>
      </div>
    }

  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button class="btn btn-primary" (click)="save()" [disabled]="!isSubmitAvailable()">
    {{'newConnectionPopup.placeConnection' | translate}}
  </button>
</div>
